import { UserSubscription } from '@creditsights/api-ui-web';
import { PageComponentTagId } from '../../../models';
import { CompanyWidgetId, CompanyWidgetsOrderConfig, OVERVIEW_TAB_WIDGET_ID } from '../Company.constants';

export const CS_LEFT_CONTAINER_WIDGETS: CompanyWidgetId[] = [
  OVERVIEW_TAB_WIDGET_ID.COMPANY_OVERVIEW,
  PageComponentTagId.CREDIT_VIEW,
  OVERVIEW_TAB_WIDGET_ID.COMPANY_FIRST_SEGMENT,
  OVERVIEW_TAB_WIDGET_ID.COMPANY_SECOND_SEGMENT,
  OVERVIEW_TAB_WIDGET_ID.RISK_PRODUCT,
];

export const CS_MIDDLE_CONTAINER_WIDGETS: CompanyWidgetId[] = [
  OVERVIEW_TAB_WIDGET_ID.RECENTLY_PUBLISHED,
  OVERVIEW_TAB_WIDGET_ID.DEALS,
  PageComponentTagId.KEY_METRICS,
  PageComponentTagId.RELATIVE_VALUE,
  PageComponentTagId.ESG,
  PageComponentTagId.FLEX1,
  PageComponentTagId.CAPITAL_STRUCTURE,
  PageComponentTagId.MNA,
  PageComponentTagId.LITIGATION,
  PageComponentTagId.MANAGEMENT_COMMENTARY,
  PageComponentTagId.FLEX2,
  PageComponentTagId.OPERATING_CONDITION,
  PageComponentTagId.FINANCIAL_CONDITION,
  PageComponentTagId.FLEX3,
  PageComponentTagId.LEASE_ADJUSTMENTS,
  PageComponentTagId.CORPORATE_STRUCTURE,
  PageComponentTagId.COVENANTS,
  PageComponentTagId.FLEX4,
  PageComponentTagId.SIZE_GEOGRAPHY,
  PageComponentTagId.FLEX5,
];
export const CS_RIGHT_CONTAINER_WIDGETS: CompanyWidgetId[] = [
  OVERVIEW_TAB_WIDGET_ID.CS_VIEW,
  PageComponentTagId.RISKS_CATALYSTS,
];
export const NON_CS_LEFT_CONTAINER_WIDGETS: CompanyWidgetId[] = [
  OVERVIEW_TAB_WIDGET_ID.COMPANY_OVERVIEW,
  OVERVIEW_TAB_WIDGET_ID.COMPANY_FIRST_SEGMENT,
  OVERVIEW_TAB_WIDGET_ID.COMPANY_SECOND_SEGMENT,
  OVERVIEW_TAB_WIDGET_ID.RISK_PRODUCT,
];
export const NON_CS_RIGHT_CONTAINER_WIDGETS: CompanyWidgetId[] = [
  OVERVIEW_TAB_WIDGET_ID.RECENTLY_PUBLISHED,
  OVERVIEW_TAB_WIDGET_ID.DEALS,
];
export const RP_LEFT_CONTAINER_WIDGETS: CompanyWidgetId[] = [OVERVIEW_TAB_WIDGET_ID.COMPANY_OVERVIEW];
export const RP_RIGHT_CONTAINER_WIDGETS: CompanyWidgetId[] = [OVERVIEW_TAB_WIDGET_ID.RECENTLY_PUBLISHED];

export const DEFAULT_COMPANY_WIDGETS_ORDER_CONFIG: Record<UserSubscription, CompanyWidgetsOrderConfig> = {
  [UserSubscription.CS_CR_LFI]: {
    leftSideWidgets: CS_LEFT_CONTAINER_WIDGETS,
    middleWidgets: CS_MIDDLE_CONTAINER_WIDGETS,
    rightSideWidgets: CS_RIGHT_CONTAINER_WIDGETS,
  },
  [UserSubscription.CS_CR]: {
    leftSideWidgets: CS_LEFT_CONTAINER_WIDGETS,
    middleWidgets: CS_MIDDLE_CONTAINER_WIDGETS,
    rightSideWidgets: CS_RIGHT_CONTAINER_WIDGETS,
  },
  [UserSubscription.CS_LFI]: {
    leftSideWidgets: CS_LEFT_CONTAINER_WIDGETS,
    middleWidgets: CS_MIDDLE_CONTAINER_WIDGETS,
    rightSideWidgets: CS_RIGHT_CONTAINER_WIDGETS,
  },
  [UserSubscription.CR_LFI]: {
    leftSideWidgets: NON_CS_LEFT_CONTAINER_WIDGETS,
    middleWidgets: [],
    rightSideWidgets: NON_CS_RIGHT_CONTAINER_WIDGETS,
  },
  [UserSubscription.CS]: {
    leftSideWidgets: CS_LEFT_CONTAINER_WIDGETS,
    middleWidgets: CS_MIDDLE_CONTAINER_WIDGETS,
    rightSideWidgets: CS_RIGHT_CONTAINER_WIDGETS,
  },
  [UserSubscription.CR]: {
    leftSideWidgets: NON_CS_LEFT_CONTAINER_WIDGETS,
    middleWidgets: [],
    rightSideWidgets: NON_CS_RIGHT_CONTAINER_WIDGETS,
  },
  [UserSubscription.LFI]: {
    leftSideWidgets: NON_CS_LEFT_CONTAINER_WIDGETS,
    middleWidgets: [],
    rightSideWidgets: NON_CS_RIGHT_CONTAINER_WIDGETS,
  },
  [UserSubscription.RP]: {
    leftSideWidgets: RP_LEFT_CONTAINER_WIDGETS,
    middleWidgets: [],
    rightSideWidgets: RP_RIGHT_CONTAINER_WIDGETS,
  },
};
